<div class="community-settings container-xl py-3" *transloco="let t">
  <header class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
    <h1 class="h3 mb-0">⚙️ {{ t('community.settings.title') }}</h1>
    <a class="btn btn-outline-secondary btn-sm" [routerLink]="communityLink()">← {{ t('community.thread.back') }}</a>
  </header>

  @if (error(); as key) {
    <div class="alert alert-danger d-flex justify-content-between align-items-start">
      <span>{{ t(key) }}</span>
      <button type="button" class="btn-close" (click)="error.set(null)"></button>
    </div>
  }

  @if (loading()) {
    <div class="text-center py-4"><div class="spinner-border" role="status"></div></div>
  } @else {
    <p class="text-muted small">{{ t('community.settings.hint') }}</p>

    <div class="table-responsive mb-4">
      <table class="table table-sm align-middle">
        <thead>
          <tr>
            <th>{{ t('community.settings.kind_label') }}</th>
            @for (field of fields; track field) {
              <th class="text-center">{{ t('community.settings.field.' + field) }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (kind of kinds(); track kind) {
            <tr>
              <td>
                {{ t('community.notifications.kind.' + kind) }}
                @if (isMandatory(kind)) {
                  <span class="badge bg-secondary ms-1">{{ t('community.settings.mandatory') }}</span>
                }
              </td>
              @for (field of fields; track field) {
                <td class="text-center">
                  <input class="form-check-input" type="checkbox"
                         [checked]="flagsFor(kind)[field]"
                         [disabled]="isMandatory(kind) || saving() === kind || (field === 'push' && !pushEnabledOnServer())"
                         (change)="toggle(kind, field)" />
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (translationAvailable()) {
      <section class="card mb-4">
        <div class="card-body">
          <h2 class="h6">{{ t('community.translate.settings_title') }}</h2>
          <p class="text-muted small mb-2">{{ t('community.translate.settings_hint') }}</p>

          @if (translationError(); as key) {
            <div class="alert alert-warning py-2 small">{{ t(key) }}</div>
          }

          <div class="table-responsive">
            <table class="table table-sm align-middle mb-0">
              <tbody>
                @for (locale of translationLocales(); track locale) {
                  <tr>
                    <td>{{ languageName(locale) }} <span class="text-muted small">({{ locale }})</span></td>
                    <td class="text-end" style="width: 12rem">
                      <select class="form-select form-select-sm"
                              [value]="translationMode(locale)"
                              [disabled]="translationSaving() === locale.toLowerCase()"
                              (change)="setTranslationMode(locale, $any($event.target).value)">
                        @for (m of translationModes; track m) {
                          <option [value]="m" [selected]="translationMode(locale) === m">{{ t('community.translate.mode_' + m) }}</option>
                        }
                      </select>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </section>
    }

    @if (pushEnabledOnServer()) {
      <section class="card">
        <div class="card-body">
          <h2 class="h6">{{ t('community.settings.push_title') }}</h2>
          <p class="text-muted small mb-2">{{ t('community.settings.push_hint') }}</p>

          @if (pushError(); as key) {
            <div class="alert alert-warning py-2 small">{{ t(key) }}</div>
          }

          @if (!pushSupported) {
            <p class="text-muted small">{{ t('community.settings.push_unsupported') }}</p>
          } @else if (pushSubscribed()) {
            <button type="button" class="btn btn-sm btn-outline-danger" [disabled]="pushBusy()" (click)="unsubscribeFromPush()">
              {{ t('community.settings.push_disable') }}
            </button>
          } @else {
            <button type="button" class="btn btn-sm btn-primary" [disabled]="pushBusy() || !pushPublicKey()" (click)="subscribeToPush()">
              {{ t('community.settings.push_enable') }}
            </button>
          }
        </div>
      </section>
    }
  }
</div>
